//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            active: 'stars',
            showGameFinishedPlanetPopup: false,
            activePlanet: {},
            tabs: [
                {
                    name: 'stars',
                    component: 'game-achievements-tab-stars',
                    label: this.$lang.get('achievements.star'),
                    icon: {
                        name: 'star',
                        x: 380
                    }
                },
                {
                    name: 'networking',
                    component: 'game-achievements-tab-brain',
                    label: this.$lang.get('achievements.connections'),
                    icon: {
                        name: 'brain',
                        x: 550
                    }
                },
                {
                    name: 'badges',
                    component: 'game-achievements-tab-badges',
                    label: this.$lang.get('achievements.achievements'),
                    icon: {
                        name: 'badge',
                        x: 760
                    }
                },
                {
                    name: 'gifts',
                    component: 'game-achievements-tab-gifts',
                    label: this.$lang.get('achievements.pieces'),
                    icon: {
                        name: 'puzzle',
                        x: 1030
                    }
                }
            ]
        };
    },

    computed: {
        avatar () {
            return this.$store.getters.avatar;
        },
        nickname () {
            return this.$store.getters.nickname;
        },
        activeTab () {
            return this.tabs.find(tab => tab.name === this.active);
        },
        planets () {
            return this.$store.getters.planets.map((planet, index) => {
                let finished = this.$store.getters.hasUserFinishedWeek(planet.week);

                return {
                    ...planet,
                    finished,
                    image: `/images/game/achievements/${!finished ? planet.name['de'].toLowerCase() + '_locked' : planet.name['de'].toLowerCase()}.png`,
                    x: 105 + (index % 2 * 170),
                    y: 450 + (Math.floor(index / 2) * 170)
                };
            });
        }
    },

    methods: {
        goToPlanet (planet) {
            if (planet.finished) {
                this.activePlanet = planet;
                this.showGameFinishedPlanetPopup = true;
            }
        }
    }
};
